import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { SalesPageShort } from './components/SalesPageShort';
export function App() {
  useEffect(() => {
    // Meta Pixel Code - Safe injection
    const pixelId = '3070568583125644';
    // Check if already loaded
    if ((window as any).fbq) return;
    // Initialize fbq
    const fbq = function (...args: any[]) {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        ;
        (fbq as any).queue.push(args);
      }
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    (window as any).fbq = fbq;
    (window as any)._fbq = fbq;
    // Load the script safely
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel
    fbq('init', pixelId);
    fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen relative" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <SalesPageShort data-id="element-2" />
      <SocialProofPopup data-id="element-3" />
    </div>;
}